import { Link } from "react-router-dom";
import { pendingActions, type PendingAction } from "@/pages/admin/dashboard/dashboardData";

const BUBBLE: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function PendingActions() {
  return (
    <section className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-heading text-xl text-foreground-950 font-semibold">Pending actions</h2>
        <span className="text-xs text-foreground-500">
          {pendingActions.reduce((sum, action) => sum + action.count, 0)} items need attention
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mt-5">
        {pendingActions.map((action: PendingAction) => (
          <div
            key={action.label}
            className="flex items-center gap-3 bg-background-100 border border-background-200 rounded-lg p-4"
          >
            <span
              className={`w-10 h-10 flex items-center justify-center rounded-full shrink-0 ${BUBBLE[action.tone]}`}
            >
              <i className={`${action.icon} text-lg`}></i>
            </span>
            <div className="min-w-0 flex-1">
              <p className="font-heading text-2xl font-semibold text-foreground-950 leading-none">
                {action.count}
              </p>
              <p className="text-xs text-foreground-600 mt-1 truncate">{action.label}</p>
            </div>
            <Link
              to={action.to}
              className="text-xs font-semibold text-primary-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              View All
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}